"use client";

import { motion, type Variants } from "motion/react";
import { useInView } from "react-intersection-observer";
import Button from "../Button";
import { appLinks } from "../../routes";

export default function LinkToApp() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0,
  });

  const containerVariants: Variants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0,
        type: "spring" as const,
        damping: 0,
        stiffness: 0,
      },
    },
  };

  return (
    <section ref={ref} className="bg-white">
      <div className="section-container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          className="bg-primary-light rounded-3xl p-8 md:p-12 border-2 border-primary-600 shadow-sm"
        >
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{
                delay: 0.1,
                duration: 0.3,
                ease: "easeOut",
              }}
              className="flex-1"
            >
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                Vous connaissez déjà Formly ?
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Gagnez du temps et déposez votre formation directement sur notre
                plateforme.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{
                delay: 0,
                duration: 0.3,
                ease: "easeOut",
              }}
            >
              <Button
                onClick={() => {
                  window.location.href = appLinks.formlyCreateCourse;
                }}
                variant="primary"
                size="lg"
                showArrow
              >
                Déposer ma formation directement
              </Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
